import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M16.5 18.755h-9m9 0a3 3 0 0 1 3 3h-15a3 3 0 0 1 3-3m9 0V15.38c0-.622-.503-1.125-1.125-1.125h-.871m-7.004 4.5V15.38c0-.622.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.45 7.45 0 0 1-.982-3.173m-4.025 3.173a7.45 7.45 0 0 0 .981-3.173M5.25 4.241q-1.473.214-2.916.52A6 6 0 0 0 7.73 9.732M5.25 4.241v.264c0 2.107.966 3.99 2.48 5.227M5.25 4.241V2.726c2.206-.31 4.46-.471 6.75-.471s4.545.16 6.75.47v1.516M7.73 9.732a6.7 6.7 0 0 0 2.748 1.35m8.272-6.841v.264c0 2.107-.966 3.99-2.48 5.227m2.48-5.491a46 46 0 0 1 2.916.52 6 6 0 0 1-5.395 4.971m0 0a6.7 6.7 0 0 1-2.749 1.35m0 0a6.8 6.8 0 0 1-3.044 0"
    }, null, -1)
  ])))
}
export default { render: render }